module.exports = __webpack_public_path__ + "img/info.c2bb46b5.png";